import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormService } from '../form.service';

export const MAX_CLAIM_AMOUNT_HUF = 30_000_000;

export function claimAmountMaxHufValidator(formService: FormService): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const amount = control.value as string | number | null;
    const currency = control.parent?.get('currency_iso')?.value as string | undefined;
    if (!amount || !currency) {
      return null;
    }

    const huf = formService.convertClaimAmountToHuf(+amount, currency);
    if (huf > MAX_CLAIM_AMOUNT_HUF) {
      return {
        max: {
          max: formService.getMaxClaimOriginalAmountInCurrency(currency),
          actual: amount,
        },
      };
    }
    return null;
  };
}
